import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import ImgBox from '@blade-sxp/tools/components/img-box.vue';
import Divide from '@blade-sxp/tools/pages/one-one/components/divide.vue';
import Btn from '@blade-sxp/tools/pages/one-one/components/btn.vue';
import { Status } from '@blade-sxp/tools/interfaces';
// import { CompareData, OneToOneForm, Status } from '@blade-sxp/tools/interfaces';
import { getCompareResult } from '@blade-sxp/tools/apis';
let Tools = class Tools extends Vue {
    status = Status.Init;
    Status = Status;
    percent = '0';
    routeData = {};
    form = {
        firstImage: {},
        secondImage: {},
    };
    localStorageParam = '';
    check(val) {
        if (val.firstImage.value && val.secondImage.value) {
            this.status = Status.Prepare;
        }
        else {
            this.status = Status.Init;
        }
    }
    mounted() {
        this.localStorageParam = localStorage.getItem('param') || '';
        if (this.localStorageParam) {
            const routeData = JSON.parse(this.localStorageParam);
            // if (routeData.objectId) {
            this.$set(this.form.firstImage, 'value', routeData.img);
            // }s
            localStorage.setItem('param', '');
        }
    }
    init() {
        this.$refs['oneToTwoFrom']?.resetFields();
        this.status = Status.Init;
    }
    async begin() {
        try {
            let routeData = {
                objectId: '',
                businessType: '',
                incidentType: '',
                taskId: '',
                featureValue: '',
                version: '',
            };
            // 一键搜索新开页面参数
            if (this.localStorageParam) {
                const param = JSON.parse(this.localStorageParam);
                routeData.objectId = param.objectId;
                routeData.businessType = param.businessType;
                routeData.incidentType = param.incidentType;
                routeData.taskId = param.taskId;
                routeData.featureValue = param.featureValue;
                routeData.version = param.version;
            }
            // if (this.$route.query.param) {
            //   const param = JSON.parse(this.$route.query.param as string);
            //   routeData.objectId = param.objectId;
            //   routeData.businessType = param.businessType;
            // }
            this.status = Status.Incompare;
            const form = {};
            let i;
            for (i in this.form) {
                const sourceImage = this.form[i];
                form[i] =
                    sourceImage.type === 0
                        ? {
                            imageLib: {
                                libImageUrl: sourceImage.value,
                                libName: sourceImage.libName,
                                name: sourceImage.name,
                                portraitId: sourceImage.portraitId,
                            },
                        }
                        : {
                            imageFeature: {
                                feature: {
                                    featureType: i === 'firstImage' && routeData.version && !sourceImage.featureType ? 'face' : sourceImage.featureType,
                                    featureValue: 'firstImage' && routeData.version && !sourceImage.featureType ? routeData.featureValue : sourceImage.featureValue,
                                    version: i === 'firstImage' && routeData.version && !sourceImage.featureType ? routeData.version : sourceImage.version,
                                },
                                // feature: {
                                //   featureType: sourceImage.featureType,
                                //   featureValue: sourceImage.featureValue,
                                //   version: sourceImage.version,
                                // },
                                imageBase64: sourceImage.value,
                            },
                            objectId: i === 'firstImage' && routeData.objectId && !sourceImage.featureType ? routeData.objectId : null,
                            businessType: i === 'firstImage' && routeData.businessType && !sourceImage.featureType ? routeData.businessType : null,
                            incidentType: i === 'firstImage' && routeData.incidentType && !sourceImage.featureType ? routeData.incidentType : null,
                            taskId: i === 'firstImage' && routeData.taskId && !sourceImage.featureType ? routeData.taskId : null,
                        };
            }
            const res = await getCompareResult(form);
            this.percent = '' + res;
            this.status = Status.Finish;
        }
        catch (err) {
            this.$message.error(err?.data?.error || `${this.$t('common.serverError')}`);
            this.status = Status.Prepare;
        }
    }
};
__decorate([
    Watch('form', { immediate: true, deep: true })
], Tools.prototype, "check", null);
Tools = __decorate([
    Component({
        name: 'faceOne2One',
        components: { BlurPicture, ImgBox, 'st-device': Divide, 'st-btn': Btn },
        i18n: {
            messages: {
                en: {
                    face: 'Face',
                    invalid: '人像已经过期，不参与布控、检索等操作，7天后系统自动删除相关数据。',
                },
                zh: {
                    face: '人脸',
                    invalid: '人像已经过期，不参与布控、检索等操作，7天后系统自动删除相关数据。',
                },
            },
        },
    })
], Tools);
export default Tools;
